import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import listQueryFilter from 'components/hoc/listQueryFilter';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { fetchMembershipPools } from 'store/actions/membership-pools/fetchMembershipPools';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import { deleteMembershipPool } from 'store/actions/membership-pools/deleteMembershipPools';
import MembershipPoolsListFilters from './MembershipPoolsListFilters';

const MembershipPoolsList = (props) => {
    const {
        actionType,
        location,
        resource,
        translate,
        updateQuery,
    } = props;

    return (
        <div>
            <MembershipPoolsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchMembershipPools }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    backgroundToggle={ {
                        condition: true,
                        color: theme.palette.chinook,
                        key: 'id',
                    } }
                >
                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '20%',
                        } }
                        source='name'
                        label={ translate('filters.components.name.label') }
                    />

                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '20%',
                        } }
                        source='size'
                        label={ translate('fields.size') }
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        resource={ resource }
                    >
                        <EditAction />

                        <DeleteAction action={ deleteMembershipPool } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

MembershipPoolsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

const enhance = compose(
    listQueryFilter,
    translate,
);

export default enhance(MembershipPoolsList);



// WEBPACK FOOTER //
// ./src/pages/membership-pools/list/MembershipPoolsList.js